<template>
  <div class="main-wrap">
    <main-header />
    <div class="space-top">
      <Contact :items="['استفسار']" :type="2" />
    </div>
    <main-footer />
  </div>
</template>

<style scoped lang="scss">
@import '~/assets/pages';
</style>

<script>
import Header from '~/components/Header'
import Footer from '~/components/Footer'
import Contact from '~/components/Forms/Contact'

export default {
  components: {
    'main-header': Header,
    'main-footer': Footer,
    Contact,
  },
  head() {
    const title = this.$t("seo.contact.title");
    const desc = this.$t("seo.contact.desc");
    return {
      title,
      meta: [
        { hid: "description", name: "description", content: desc },
        { hid: "og:title", property: "og:title", content: title },
        { hid: "og:description", property: "og:description", content: desc },
        { hid: "og:url", property: "og:url", content: `https://www.motanamy.com${this.$route.path}` },
        { hid: "twitter:title", name: "twitter:title", content: title },
        { hid: "twitter:description", name: "twitter:description", content: desc },
      ],
    };
  },
  computed: {
    isMobile() {
      const xsDown = this.$store.state.breakpoints.xsDown
      return xsDown.indexOf(this.$mq) > -1
    }
  }
}
</script>
